// calculatorEngine.js — rekenlogica van de Verduurzaamwijzer-calculator (v0.4, 3 nov 2026)
// Pure functies, geen UI. Bronnen: Thuisbatterijgids 2027 (Verduurzaamwijzer), Staatsblad 2025/17, Gaslicht.com, RWTH Aachen.
// NIET laten herschrijven door een AI-builder: wijzig alleen de constanten en de batterijtabellen (VAST, STEKKER).


const PRIJS = { laag:0.28, midden:0.33, hoog:0.40 };
const TERUG = 0.10;            // terugleververgoeding 2027–2030: min. helft kale tarief (€0,08–0,13)
const TERUGKOSTEN = 0.04;      // terugleverkosten nu, per kWh
const WP = 0.43, OPB = 900, STIJG = 0.02, CO2 = 0.3;
const DYN = 40;                // € per bruikbare kWh batterij per jaar bij slim laden/handelen
const CYCLI_ZON = 300, CYCLI_DYN = 600;
const PROFIEL = { avond:0.20, verspreid:0.30, overdag:0.42 };
const CAPS = [5,10,15,20];
const VERBRUIK_OPT = { laag:2300, gemiddeld:3500, hoog:4500, veel:6500 };
const PANELEN_OPT = { geen:0, tot8:6, p9_14:11, p15:18 };

// Vaste batterijen: prijs all-in incl. omvormer, installatie en 21% btw (richtprijzen 23-10-2026). est = opgebouwde schatting (≈).
const VAST = [
  { id:'grp5',  merk:'GRP Energy', model:'GRP-Graphene', kwh:5,  prijs:5672,  gar:15, cycli:20000, partner:true, note:'1 module van 5 kWh, later uitbreidbaar; eigen sturing, werkt met elk dynamisch contract; grafeen' },
  { id:'grp10', merk:'GRP Energy', model:'GRP-Graphene', kwh:10, prijs:8803,  gar:15, cycli:20000, partner:true, note:'2 modules van 5 kWh; eigen sturing, werkt met elk dynamisch contract; grafeen' },
  { id:'grp15', merk:'GRP Energy', model:'GRP-Graphene', kwh:15, prijs:11934, gar:15, cycli:20000, partner:true, note:'3 modules van 5 kWh; eigen sturing, werkt met elk dynamisch contract; grafeen' },
  { id:'grp20', merk:'GRP Energy', model:'GRP-Graphene', kwh:20, prijs:15065, gar:15, cycli:20000, partner:true, note:'4 modules van 5 kWh; eigen sturing, werkt met elk dynamisch contract; grafeen' },
  { id:'ecoflow', merk:'EcoFlow', model:'PowerOcean', kwh:15.3, prijs:8500, gar:15, cycli:6000, note:'3-fase aansluiting nodig; prijs is het midden van € 8.100 – 8.900' },
  { id:'enphase', merk:'Enphase', model:'IQ Battery 5P (3×)', kwh:15, prijs:12036, gar:15, cycli:6000, est:true, note:'AC-gekoppeld; noodstroom vraagt een extra System Controller' },
  { id:'huawei', merk:'Huawei', model:'LUNA2000-S1', kwh:13.8, prijs:8867, gar:15, cycli:null, est:true, note:'15 jaar garantie alleen na registratie in de app; met Huawei-hybride omvormer' },
  { id:'zonneplan', merk:'Zonneplan', model:'Nexus', kwh:15, prijs:6643, gar:10, cycli:6000, note:'slimme sturing alleen met een Zonneplan-energiecontract' },
  { id:'pylontech', merk:'Pylontech', model:'Force H2', kwh:14.2, prijs:8964, gar:10, cycli:6000, est:true, note:'Belgische prijsindicatie, met hybride omvormer en installatie' },
  { id:'sessy', merk:'Sessy', model:'Thuisbatterij 15 kWh', kwh:15, prijs:9800, gar:10, cycli:6000, note:'omvormer ingebouwd; € 9.400 + installatie ca. € 400' },
  { id:'growatt', merk:'Growatt', model:'APX HV', kwh:15, prijs:6998, gar:10, cycli:null, est:true, note:'3 modules + MIN/MOD-XH omvormer; laadcycli niet opgegeven' },
  { id:'sungrow', merk:'Sungrow', model:'SBR HV', kwh:16, prijs:9589, gar:10, cycli:null, est:true, note:'Duitse prijs omgerekend naar 21% btw, plus installatie; laadcycli niet opgegeven' },
  { id:'tesla', merk:'Tesla', model:'Powerwall 3', kwh:13.5, prijs:9499, gar:10, cycli:Infinity, note:'onbeperkte cycli bij eigen verbruik en uurprijzen; grens 37,8 MWh bij onbalanshandel' },
  { id:'alphaess', merk:'AlphaESS', model:'SMILE-G3', kwh:9.3, prijs:6716, gar:10, cycli:10000, note:'BAT-9.3S + S5 omvormer, incl. installatie' },
  { id:'byd', merk:'BYD', model:'Battery-Box Premium HVM', kwh:13.8, prijs:9115, gar:10, cycli:6000, est:true, note:'Belgische prijsindicatie, met hybride omvormer' },
  { id:'dyness', merk:'Dyness', model:'Tower T10', kwh:10.7, prijs:5176, gar:10, cycli:6000, est:true, note:'T10 + hybride omvormer en installatie' },
  { id:'sigenergy', merk:'Sigenergy', model:'SigenStor', kwh:10.8, prijs:9250, gar:10, cycli:10000, note:'2 × BAT 5.0, omvormer ingebouwd; midden van € 8.500 – 10.000' },
];
// Stekkerbatterijen: zonder installatie, standaard max. 800 W naar het huis, rendement 78–88%, tellen niet mee voor energielabel of lening.
const STEKKER = [
  { merk:'HYXi', model:'Halo', kwh:15, prijs:3299, gar:10, cycli:10000 },
  { merk:'Marstek', model:'Venus E 3.0', kwh:15.4, prijs:3597, gar:10, cycli:6000 },
  { merk:'Zendure', model:'SolarFlow 2400 AC+', kwh:13.9, prijs:3525, gar:10, cycli:6000 },
  { merk:'EcoFlow', model:'STREAM AC 5000', kwh:15.1, prijs:3898, gar:10, cycli:10000 },
  { merk:'Jackery', model:'SolarVault 3 Pro Max AC', kwh:15.1, prijs:3834, gar:10, cycli:null },
  { merk:'Indevolt', model:'PowerFlex 2000', kwh:10, prijs:3146, gar:10, cycli:8000 },
  { merk:'Anker SOLIX', model:'Solarbank 3 E2700 Pro', kwh:16.1, prijs:5694, gar:10, cycli:6000 },
  { merk:'HomeWizard', model:'Plug-In Battery', kwh:10.8, prijs:4780, gar:7, cycli:6000 },
];


// ---------- Rekenwerk ----------
function zonInvest(p){ return p>0 ? 1500 + 350*p : 0; }
function tvt(invest, besparing, degr){
  if(invest<=0) return 0; if(besparing<=0) return Infinity;
  let cum=0; for(let j=1;j<=40;j++){ const b=besparing*Math.pow(1+STIJG,j-1)*Math.pow(1-degr,j-1); cum+=b; if(cum>=invest) return j-1+(invest-(cum-b))/b; }
  return Infinity;
}
function netto(invest, besparing, degr, n){ let c=0; for(let j=1;j<=n;j++) c+=besparing*Math.pow(1+STIJG,j-1)*Math.pow(1-degr,j-1); return c-invest; }

function systeem(s, pTot, cap, dynOn, prijs, rend=0.9, loadFactor=1, dynF=1){
  const kwp = pTot*WP, opb = kwp*OPB;
  const share = (PROFIEL?.[s?.moment]||0.3) + (s?.warmtepomp?0.05:0);
  const direct = Math.min(opb*share, s?.verbruik*0.55);
  const overschot = Math.max(0, opb-direct);
  const salderbaar = Math.min(overschot, Math.max(0, s?.verbruik-direct));
  const restBehoefte = Math.max(0, s?.verbruik-direct);
  const bruikbaar = cap*0.9;
  const verschoven = cap>0 ? Math.min(overschot*0.8, bruikbaar*230, restBehoefte*0.9)*loadFactor : 0;
  const nuttig = verschoven*rend;
  const terug = Math.max(0, overschot-verschoven);
  const ingekocht = Math.max(0, s?.verbruik-direct-nuttig);
  const dynOpbrengst = dynOn && cap>0 ? bruikbaar*DYN*loadFactor*dynF : 0;
  const kosten2027 = ingekocht*prijs - terug*TERUG - dynOpbrengst;
  const gesaldeerd = Math.min(opb, s?.verbruik);
  const kostenNu = (s?.verbruik-gesaldeerd)*prijs + Math.max(0, overschot-verschoven)*TERUGKOSTEN - Math.max(0, opb-s?.verbruik)*TERUG - dynOpbrengst;
  return { kwp, opb, share: opb>0?direct/opb:0, direct, overschot, salderbaar, verschoven, nuttig, terug, ingekocht, dynOpbrengst, kosten2027, kostenNu, eigen: opb>0 ? (direct+nuttig)/opb : 0 };
}

// Levensduurmodel (zie aannames): kalenderveroudering + cyclusverlies; versleten bij 60% restcapaciteit; vervanging tegen 85% van de huidige prijs.
const LT = 25;
function levensduur(b, cpy){
  const graf = !!b?.partner;
  const cal = graf ? 0.005 : 0.02, cycLoss = graf ? 0.10 : 0.30;
  const cycli = b?.cycli===null ? 6000 : b?.cycli;
  const capAt = t => Math.max(0, 1 - cal*t - (isFinite(cycli) ? cycLoss*(cpy*t/cycli) : 0));
  let life = LT+10;
  for(let t=1;t<=LT+10;t++){ if(capAt(t) < 0.6){ let a=capAt(t-1), c=capAt(t); life = t-1 + (a-0.6)/(a-c); break; } }
  return { capAt, life };
}
function langeTermijn(b, besp, cpy, H=LT){
  const m = levensduur(b, cpy);
  let cum=0, kosten=b?.prijs, vervangingen=0, age=0;
  for(let t=1;t<=H;t++){
    age++;
    if(age > m?.life){ vervangingen++; const rest = H-t+1; kosten += b?.prijs*0.85*Math.min(1, rest/m?.life); age = 1; }
    cum += besp*Math.pow(1+STIJG,t-1)*m?.capAt(age);
  }
  return { netto: cum-kosten, vervangingen, lifeLT: Math.min(m?.life, H), kosten: kosten };
}

// Rangschikt batterijen voor een gewenste maat. GRP (partner) staat als advies bovenaan; andere merken komen erbij als vergelijking,
// met voorrang voor merken die op 15 jaar duidelijk voordeliger zijn (netto > 1,25 × GRP + € 500).
function rankBatteries(s, pTot, cap, dynOn, prijs, dynNow){
  const z = systeem(s, pTot, 0, dynNow, prijs);
  const cpy = dynOn ? CYCLI_DYN : CYCLI_ZON;
  const BUCKET = { 5:[0,8], 10:[8,12.5], 15:[12.5,17], 20:[17,99] };
  const [lo, hi] = BUCKET?.[cap] || [0,99];
  const evalBat = (b, rend=0.9, lf=1, dynF=1) => {
    const sys = systeem(s, pTot, b?.kwh, dynOn, prijs, rend, lf, dynF);
    const besp = z?.kosten2027 - sys?.kosten2027;
    const cycli = b?.cycli===null ? 6000 : b?.cycli;
    let life = Math.min(15, cycli/cpy);
    const garEff = Math.min(b?.gar, cycli/cpy);
    const geleverd = b?.kwh*0.9*cpy*life*0.85;
    const lt = langeTermijn(b, besp, cpy, LT), kt = langeTermijn(b, besp, cpy, 15);
    return { ...b, besp, life, garEff, netto15: kt?.netto, netto25: lt?.netto, vervangingen: lt?.vervangingen, lifeLT: lt?.lifeLT, perKwh: b?.prijs/geleverd, tvt: tvt(b?.prijs, besp, 0.02), cycliAanname: b?.cycli===null, verschoven: sys?.verschoven };
  };
  const all = VAST?.map(b=>evalBat(b))?.sort((a,b)=>b?.netto25-a?.netto25);
  const cand = all?.filter(b=>b?.kwh>=lo && b?.kwh<hi);
  const grp = (cand?.filter(b=>b?.partner)?.[0]) || all?.filter(b=>b?.partner)?.sort((a,b)=>Math.abs(a?.kwh-cap)-Math.abs(b?.kwh-cap))?.[0];
  let others = cand?.filter(b=>!b?.partner)?.sort((a,b)=>b?.netto15-a?.netto15);
  if(others?.length<2){ const extra = all?.filter(b=>!b?.partner && !others?.some(o=>o?.id===b?.id))?.sort((a,b)=>Math.abs(a?.kwh-cap)-Math.abs(b?.kwh-cap) || b?.netto15-a?.netto15)?.slice(0, 2-others?.length)?.map(b=>({...b, anderMaat:true})); others = [...others, ...extra]; }
  const sterk = others?.filter(o => o?.netto15 > grp?.netto15*1.25 + 500)?.slice(0,2)?.map(o=>({...o, sterkKT:true}));
  const rest = others?.filter(o=>!sterk?.some(x=>x?.id===o?.id))?.slice(0, Math.max(0, 2-sterk?.length));
  const top = [ {...grp, advies:true}, ...sterk, ...rest ];
  const besteAnderLT = others?.filter(o=>!o?.anderMaat)?.sort((a,b)=>b?.netto25-a?.netto25)?.[0] || null;
  const grpWintLT = !besteAnderLT || grp?.netto25 >= besteAnderLT?.netto25;
  const stekker = STEKKER?.map(b=>evalBat(b, 0.83, 0.75, 0.4))?.sort((a,b)=>b?.netto15-a?.netto15)?.slice(0,3);
  return { top, cand, all, grp, besteAnderLT, grpWintLT, stekker, cpy, lo, hi };
}

function calc(s){
  const prijs = PRIJS?.[s?.scenario];
  const pB = s?.panelen, dynNow = s?.contract==='dynamisch';
  const basis = systeem(s, pB, 0, dynNow, prijs);
  const stijging = basis?.kosten2027 - basis?.kostenNu;
  const kostenZonderPanelen = s?.verbruik*prijs;

  const planZon = s?.plan?.zon, planBat = s?.plan?.bat, planDyn = s?.plan?.dyn || dynNow;
  const pN = planZon ? s?.panelenNieuw : 0, pTot = pB + pN;

  const rank = rankBatteries(s, pTot, s?.cap, planDyn, prijs, dynNow);
  const chosen = planBat ? (rank?.top?.find(b=>b?.id===s?.batId) || rank?.all?.find(b=>b?.id===s?.batId) || rank?.top?.[0] || null) : null;
  const cap = chosen ? chosen?.kwh : 0;

  const met = systeem(s, pTot, cap, planDyn, prijs);
  const stapZon = systeem(s, pTot, 0, dynNow, prijs);
  const stapBat = systeem(s, pTot, cap, dynNow, prijs);

  const zon = { aan:planZon, p:pN, invest:planZon?zonInvest(pN):0, besp: planZon ? basis?.kosten2027-stapZon?.kosten2027 : 0, bespNu: planZon ? basis?.kostenNu-stapZon?.kostenNu : 0 };
  zon.tvt = tvt(zon?.invest, zon?.besp, 0.005); zon.netto = netto(zon?.invest, zon?.besp, 0.005, 15); zon.netto25 = netto(zon?.invest, zon?.besp, 0.005, 25);

  const batDyn = chosen ? stapBat?.kosten2027 - met?.kosten2027 : 0;
  const bat = { aan:!!chosen, cap, invest: chosen?chosen?.prijs:0, bespDyn: batDyn + (chosen && dynNow ? met?.dynOpbrengst : 0), besp: chosen ? chosen?.besp : 0,
    bespNu: chosen ? stapZon?.kostenNu-stapBat?.kostenNu : 0, tvt: chosen ? chosen?.tvt : Infinity, netto: chosen ? chosen?.netto15 : 0, netto25: chosen ? chosen?.netto25 : 0, chosen };
  const dyn = { aan: planDyn && !dynNow, besp: batDyn };

  const capOpts = CAPS?.map(c=>{ const rk = rankBatteries(s, pTot, c, planDyn, prijs, dynNow); return { c, best: rk?.grp || null }; });
  const snelste = capOpts?.filter(o=>o?.best)?.reduce((a,o)=> (!a || o?.best?.tvt < a?.best?.tvt) ? o : a, null);
  const vuistregel = Math.min(20, Math.max(5, Math.ceil((s?.verbruik/365*0.6 + (s?.warmtepomp?2:0) + (s?.ev?3:0))/0.9/5)*5));
  const zonSuggest = Math.min(20, Math.max(6, Math.round(s?.verbruik*0.9/(WP*OPB))));
  const dekking = s?.verbruik>0 ? met?.opb/s?.verbruik : 0;

  const totaal = { invest: zon?.invest + bat?.invest, besp: zon?.besp + bat?.besp, bespNu: zon?.bespNu + bat?.bespNu };
  totaal.tvt = tvt(totaal?.invest, totaal?.besp, 0.012); totaal.netto = zon?.netto + bat?.netto; totaal.netto25 = zon?.netto25 + bat?.netto25;
  totaal.co2 = (basis?.ingekocht - met?.ingekocht)*CO2;

  return { prijs, basis, met, stapZon, stijging, zon, bat, dyn, rank, capOpts, snelste: snelste?snelste?.c:10, vuistregel, zonSuggest, dekking, totaal, kosten2027Plan: met?.kosten2027, kostenZonderPanelen, dynNow, pTot };
}


// ---------- Helpers voor weergave ----------
export const eur = n => (n<0?'– ':'') + '€ ' + Math.round(Math.abs(n))?.toLocaleString('nl-NL');
export const eurc = n => '€ ' + n?.toFixed(2)?.replace('.',',');
export const rng = n => n<=0 ? eur(0) : eur(n*0.85) + ' – ' + eur(n*1.15);
export const kwh = n => Math.round(n)?.toLocaleString('nl-NL') + ' kWh';
export const jr = t => !isFinite(t) ? 'niet' : t<1 ? '< 1 jaar' : (Math.round(t*2) / 2)?.toLocaleString('nl-NL') + ' jaar';
export const pct = x => Math.round(x*100) + '%';
export const naarKosten = k => k > 60 ? 'circa ' + eur(k) + ' per jaar' : 'vrijwel nul per jaar (door slim laden kan je stroomrekening per saldo zelfs iets opleveren)';

export const VERBRUIK_LABEL = { laag:'Laag', gemiddeld:'Gemiddeld', hoog:'Hoog', veel:'Veel', exact:'Exact' };
export const MOMENT_LABEL = { avond:"vooral \'s avonds", verspreid:'verspreid over de dag', overdag:'vooral overdag' };

/** Begintoestand van de wizard. */
export function initialState(){
  return { verbruikKeuze:null, verbruik:null, panelenKeuze:null, panelen:null, moment:null, warmtepomp:false, ev:false, contract:null,
    scenario:'midden', plan:{ zon:null, bat:null, dyn:null }, panelenNieuw:10, cap:10, batId:null };
}

/** Zet standaardplan en standaardmaat na de laatste vraag. */
export function afrondenAntwoorden(s){
  const n = { ...s, plan:{ ...s?.plan } };
  if(n?.plan?.zon===null) n.plan.zon = n?.panelen===0;
  if(n?.plan?.bat===null) n.plan.bat = true;
  if(n?.plan?.dyn===null) n.plan.dyn = n?.contract!=='dynamisch';
  const r0 = calc(n);
  if(n?.panelen===0) n.panelenNieuw = r0?.zonSuggest;
  n.cap = r0?.vuistregel; n.batId = null;
  return n;
}

/** Samenvatting voor het leadformulier en het CRM. */
export function leadPayload(s){
  const r = calc(s);
  return {
    verbruik_kwh: s?.verbruik, panelen_bestaand: s?.panelen, verbruiksmoment: s?.moment, warmtepomp: s?.warmtepomp, ev: s?.ev, contract: s?.contract,
    scenario_stroomprijs: s?.scenario, plan_zonnepanelen: !!s?.plan?.zon, panelen_nieuw: s?.plan?.zon ? s?.panelenNieuw : 0,
    plan_batterij: !!r?.bat?.aan, batterij: r?.bat?.chosen ? `${r?.bat?.chosen?.merk} ${r?.bat?.chosen?.model} ${r?.bat?.chosen?.kwh} kWh` : null, batterij_id: r?.bat?.chosen ? r?.bat?.chosen?.id : null,
    plan_dynamisch: !!s?.plan?.dyn, investering: Math.round(r?.totaal?.invest), besparing_per_jaar: Math.round(r?.totaal?.besp), terugverdientijd_jaar: isFinite(r?.totaal?.tvt) ? Math.round(r?.totaal?.tvt*10)/10 : null,
    netto_25_jaar: Math.round(r?.totaal?.netto25), stijging_2027: Math.round(r?.stijging), engine_versie: '0.4'
  };
}

export { PRIJS, TERUG, TERUGKOSTEN, WP, OPB, DYN, CYCLI_ZON, CYCLI_DYN, CAPS, VERBRUIK_OPT, PANELEN_OPT, VAST, STEKKER, LT, systeem, rankBatteries, calc, tvt, netto, zonInvest, levensduur, langeTermijn };
